import React, { useState } from "react";
import "./style.scss";
import { IoIosCloseCircle } from "react-icons/io";
import { Box, Button, Rating } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { postReview } from "services/user/reviewService";
import Swal from "sweetalert2";
import { PacmanLoader } from "react-spinners";


const labelsRating = {
  0.5: "Useless",
  1: "Tệ",
  1.5: "Poor",
  2: "Trung Bình",
  2.5: "Ok",
  3: "Ổn",
  3.5: "Good",
  4: "Tốt",
  4.5: "Excellent",
  5: "Tuyệt vời",
};

const ModalReview = ({ orderID, orderItemID, value, content, onClose  }) => {
    const token = localStorage.getItem("token")
    const [valueRating, setValueRating] = React.useState(value || 5);
    const [isLoading, setIsLoading] = useState(false)
    const [modal, setModal] = useState(true);
    const toggleModal = () => {
        setModal(!modal)
    }
    const [hover, setHover] = React.useState(-1);
    console.log(orderID, orderItemID)
    const [comment, setComment] = useState(content || "")
    
    function getLabelText(value) {
        return `${value} Star${value !== 1 ? "s" : ""}, ${
        labelsRating[value.toString()]
        }`;
    }

    const handlePostReview = async () => {
        const reviewDetail = {
            orderID: orderID,
            orderItemID: orderItemID,
            rating: valueRating,
            comment: comment
        }
        setIsLoading(true)
        try {
            const response = await postReview(token, reviewDetail)
            console.log(response)
            if (response.message === "Item not found or has been review already!") {
                Swal.fire({
                    title: "Bạn đã đánh giá cho sách này rồi!",
                    // text: "That thing is still around?",
                    icon: "warning"
                });
            }
            else if (response.message === "Review successfully!") {
                Swal.fire({
                    title: "Đánh giá thành công!",
                    // text: "That thing is still around?",
                    icon: "success"
                });
            }
        } 
        catch (error) {
            console.log("postReview", error)
        }
        finally {
            setIsLoading(false)
            onClose(true);
        }
    }
    return (
        <div className="modal_review">
            <div className="overlay_review">
                <div className="modal-content_review">
                    <div className="d-flex">
                        <h5 className="w-100 text-center">VIẾT ĐÁNH GIÁ CHO SÁCH</h5>
                        <IoIosCloseCircle className="close-modal ms-auto" onClick={() => onClose(false)}/>                    
                    </div>

                    <div className="mt-1 mb-3">
                        <Box
                            sx={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <Rating
                                name="hover-feedback"
                                value={valueRating}
                                precision={1}
                                readOnly={value !== undefined && value !== null && value !== ''}
                                getLabelText={getLabelText}
                                onChange={(event, newValue) => {
                                    setValueRating(newValue);
                                }}
                                onChangeActive={(event, newHover) => {
                                    setHover(newHover);
                                }}
                                emptyIcon={
                                    <StarIcon
                                    style={{ opacity: 0.55 }}
                                    fontSize="inherit"
                                    />
                                }
                            />
                            {valueRating !== null && (
                                <Box sx={{ ml: 2 }}>
                                    {labelsRating[hover !== -1 ? hover : valueRating]}
                                </Box>
                            )}
                        </Box>
                    </div>
                
                    <div className="input-container" >
                        <textarea
                            className="content_review"
                            value={comment}
                            readOnly={value !== undefined && value !== null && value !== ''}
                            onChange={(e) => {setComment(e.target.value)}}
                            placeholder="Viết nội dung đánh giá của bạn"
                        ></textarea>
                    </div>
                    {!value ? (
                        <Button className="add-btn" onClick={handlePostReview}>
                            Gửi đánh giá
                        </Button>
                    ) : (
                        <div className="mb-3"></div>
                    )}
                    
                </div>
            </div>
            {isLoading && (
                <div className="modal">
                    <div className="overlay_loading">
                        <div className="modal-content_loading">
                            <div className="d-flex">
                            <PacmanLoader color="#5e2e86"/>
                            </div>
                        </div>
                    </div>
                </div>
            )} 
        </div>
    );
};

export default ModalReview;
